// extracted by mini-css-extract-plugin
export default {"shareIcon":"shareIcon__FKOHnU"};